
import { defineComponent, provide, reactive } from 'vue';
import Editor from './components/Editor.vue';
import WidgetList from './components/WidgetList.vue';
import AttrList from './components/AttrList.vue';
import { Widget, widgetType, dataKey, State } from './types';
import createWidget from './widget/createWidget';

export default defineComponent({
	components: { Editor, WidgetList, AttrList },
	setup() {
		const rootWidget: Widget = createWidget(widgetType.LIST);
		const curWidget = reactive<Widget>(rootWidget);
		// 共享数据
		const state = reactive<State>({
			rootWidget,
			curWidget,
		});

		provide(dataKey.STATE, state);
		return { state, widgetType };
	},
});
